import React from "react";
import authentication from "@irati/auth";
import DealFavourites from "./DealFavourites";
var IsDealFavourited = function (props) {
    return (React.createElement(DealFavourites, { variables: { userId: authentication.user().uuid } }, function (apollo) {
        var _a;
        var deals = ((_a = apollo.data) === null || _a === void 0 ? void 0 : _a.dealFavourites) || [];
        var deal = deals.filter(function (t) { return t.uuid === props.dealId; })[0];
        var isFavourite = !!deal;
        return props.children({ isFavourite: isFavourite, deal: deal });
    }));
};
export default IsDealFavourited;
